var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.bonusesAndFees),function(bonus){return _c('div',{key:bonus.id,staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(bonus.label)+":")]),_vm._v(" $"+_vm._s(bonus.value)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }